import { ReactElement, useMemo } from 'react';
import moment from 'moment-timezone';

import { PlanFeaturesTypes } from '~globals/types/enums';
import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { useSubscription } from '~hooks/useSubscription';
import { useToggle } from '~hooks/useToggle';
import { isPlanStart } from '~utils/plans';
import { getFeatureAvailableToDate } from '~utils/feature';
import { formatterDate } from '~utils/formatter';

import DialogGlobalAlert from '../DialogGlobalAlert';

export const MAX_AVAILABLE_DATE = moment('2026-07-10').toDate();

const DialogAlertDisabledGiversFuncionality = (): ReactElement => {
  const { isCarrier } = useTypePartnerCompany();
  const subscription = useSubscription();

  const isEnabled = useMemo(() => {
    const hasPlanStart = isPlanStart(subscription);
    const isValidMaxDate = moment().isSameOrBefore(MAX_AVAILABLE_DATE, 'day');

    return isCarrier && hasPlanStart && isValidMaxDate;
  }, [isCarrier, subscription]);

  const [
    openAlertDisabledGiverFuncionality,
    toogleOpenAlertDisabledGiverFuncionality,
  ] = useToggle(isEnabled);

  const maxAvailableDateText = useMemo(
    () =>
      formatterDate(
        moment(
          getFeatureAvailableToDate(PlanFeaturesTypes.MgmGiversModule),
        ).add(1, 'day'),
        { format: 'DD/MM/YYYY' },
      ),
    [],
  );

  return (
    <DialogGlobalAlert
      open={openAlertDisabledGiverFuncionality}
      onClose={() => toogleOpenAlertDisabledGiverFuncionality(false)}
      title="📣 Cambios en los planes Routix"
      descriptions={[
        <>
          Desde el <b>{maxAvailableDateText}</b>, los planes <b>START</b>{' '}
          dejarán de incluir la funcionalidad de dadores de carga.
        </>,
        <>
          La buena noticia es que los planes <b>PLUS</b> y superiores continúan
          ofreciendo esta funcionalidad.
        </>,
        // eslint-disable-next-line max-len
        'Te recomendamos realizar la actualización antes de esa fecha para evitar interrupciones en el servicio.',
      ]}
    />
  );
};

export default DialogAlertDisabledGiversFuncionality;
